import { colorForId } from "./colors";

/** Brand-adjacent hues for the providers we ship an adapter for. Anything else
 * gets a deterministic colour so a self-hosted provider is still distinguishable
 * from its neighbours rather than sharing one anonymous grey. */
const PROVIDER_COLORS: Record<string, string> = {
  claude: "#d97757",
  codex: "#10a37f",
};

/**
 * The dot colour identifying a provider in the runtime controls.
 *
 * A dot replaced the old text glyphs (`✦` / `>_`): the control row is 24px
 * tall, and at that size a glyph reads as decoration while a 6px colour chip
 * reads as identity — which is the only job it has there.
 */
export function providerColor(providerId: string): string {
  return PROVIDER_COLORS[providerId] ?? colorForId(providerId || "unknown");
}

const PROVIDER_NAMES: Record<string, string> = {
  claude: "Claude",
  codex: "Codex",
};

/** The provider's display name, for tooltips and accessible labels. */
export function providerName(providerId: string): string {
  return PROVIDER_NAMES[providerId] ?? providerId;
}
